import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";
import FormInputs from "../../../../../../components/UI/FormInputs";

const YesOrNoFields = ({ showNotes, notes, options, col, failedValue, list, label, appendClass, readOnly, validation, useHeaderRadios, ...props }) => {
    const formData = props.formData || {};
    const listWithNames = (list || []).filter((t) => isSet(t.name, '') !== '');
    const isHeaderOptionSelected = (optionValue) =>
        listWithNames.length > 0 && listWithNames.every((t) => formData[t.name] === optionValue);
    const setAllToOption = (optionValue) => {
        if (props.updateFormData && listWithNames.length) {
            const patch = listWithNames.reduce((acc, t) => ({ ...acc, [t.name]: optionValue }), {});
            props.updateFormData(patch);
        }
    };

    return (
        <>      
            {isSet(notes) && notes.length > 0 ?
                <div className="col-4">
                    <strong>{label}</strong>
                        <ul style={{ marginLeft: '30px'}}>
                            {notes.map((itm, itmIndex) => {
                                return (
                                    <li key={itmIndex}>{itm}</li>
                                )
                            })}
                        </ul>
                </div>
            : <></>}

                <div className={`${isSet(col,'col-8')} px-0 overflow-auto`}>
                    <table className={`table sh_responsivetable table-bordered mb-0  ${appendClass}`}>
                        <thead>
                            <tr>
                                <th>
                                    {useHeaderRadios ? 'VITALS' : (props.defaultBtnLabel ? (
                                        <a onClick={() => props.updateFormData(isSet(props.defaultValues, {}))} className="badge bg-blue-soft text-light cursor-pointer custom-btn" style={{ cursor: 'pointer' }}>
                                            {props.defaultBtnLabel}
                                        </a>
                                    ) : '')}
                                </th>
                                {useHeaderRadios ? (
                                    options.map((option, optionIndex) => (
                                        <th key={optionIndex} className="text-left align-top">
                                            <div className="d-flex align-items-center">
                                                <div className="form-check mb-0">
                                                    <FormInputs
                                                        className="form-check-input"
                                                        type="Radio"
                                                        name="yesorno_header_radio"
                                                        id={`yesorno_header_${optionIndex}`}
                                                        value={isHeaderOptionSelected(option.value)}
                                                        readOnly={readOnly}
                                                        changeHandler={() => setAllToOption(option.value)}
                                                    />
                                                </div>
                                                <span className="form-check-label ml-1 mb-0">{option.label}</span>
                                            </div>
                                        </th>
                                    ))
                                ) : (
                                    options.map((option, optionIndex) => (
                                        <th key={optionIndex}>{option.label}</th>
                                    ))
                                )}
                                {showNotes && <th>NOTES</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {!useHeaderRadios && props.defaultBtnLabel && (
                                <tr className="sh_badgehide-md mb-0">
                                    <td colSpan={1 + options.length + (showNotes ? 1 : 0)}>
                                        <a onClick={() => props.updateFormData(isSet(props.defaultValues, {}))} className="badge bg-blue-soft text-light cursor-pointer custom-btn" style={{ cursor: 'pointer' }}>
                                            {props.defaultBtnLabel}
                                        </a>
                                    </td>
                                </tr>
                            )}
                            {list.map((tData, tIndex) => {
                                const isParentQuestion = !isSet(tData.name, '') || tData.name === '';
                                const labelContent = (
                                    <>
                                        {(isSet(tData.isSubField, false) === true) ? (
                                            <span style={{ paddingLeft: '20px' }}>{tData.label}</span>
                                        ) : (
                                            tData.label
                                        )}
                                        {(isSet(validation) && isSet(validation[tData.name], '') !== '' ? (
                                            <span className="text-danger m-1">
                                                {isSet(validation[tData.name], '')}
                                            </span>
                                        ) : (
                                            ''
                                        ))}
                                    </>
                                );
                                const colSpanAll = 1 + options.length + (showNotes ? 1 : 0);

                                return (
                                    <tr
                                        key={tIndex}
                                        className={isParentQuestion ? 'sh_parent-question-row' : ''}
                                        style={{ backgroundColor: tIndex % 2 === 0 ? '#F7F9FF' : undefined }}
                                    >
                                        {/* Mobile only: parent question as single full-width cell (no Yes/No columns) */}
                                        {isParentQuestion && (
                                            <td
                                                colSpan={colSpanAll}
                                                className="sh_parent-question-label d-md-none border"
                                            >
                                                {labelContent}
                                            </td>
                                        )}
                                        {/* Desktop: first cell (label) - hidden on mobile for parent rows */}
                                        <td
                                            {...isSet(tData.attr, {})}
                                            className={isParentQuestion ? 'd-none d-md-table-cell' : ''}
                                        >
                                            {labelContent}
                                        </td>
                                        {/* Yes/No option cells - hidden on mobile for parent rows */}
                                        {options.map((option, optionIndex) => {
                                            const value = (isSet(props.formData[tData.name], null) == option.value);
                                            let tdStyle = {};
                                            const activeFailedValue = isSet(tData.failedValue) ? tData.failedValue : failedValue;
                                            if (isSet(activeFailedValue, null) !== null && activeFailedValue.indexOf(option.value) >= 0 && activeFailedValue.indexOf(isSet(props.formData[tData.name], null)) === activeFailedValue.indexOf(option.value)) {
                                                tdStyle = { backgroundColor: 'red', borderColor: 'red' };
                                            }
                                            return (
                                                <td
                                                    data-label={option.label}
                                                    key={optionIndex}
                                                    className={isParentQuestion ? 'd-none d-md-table-cell' : ''}
                                                >
                                                    {(isSet(tData.name, '') !== '') ? (
                                                        <div className="form-check">
                                                            <FormInputs
                                                                className="form-check-input"
                                                                type="Radio"
                                                                style={{ ...tdStyle }}
                                                                name={`${tData.name}_${tIndex}`}
                                                                id={`checkbox_${tData.name}${tIndex}_${optionIndex}`}
                                                                value={value}
                                                                readOnly={readOnly}
                                                                onKeyPress={tData.onKeyPress}
                                                                changeHandler={() => props.changeHandler(tData.name, option.value)}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </td>
                                            );
                                        })}
                                        {showNotes && (
                                            <td className={isParentQuestion ? 'd-none d-md-table-cell' : ''}>
                                                {(isSet(tData.name, '') !== '') ? (
                                                    <FormInputs
                                                        type="TextArea"
                                                        name={tData.notesName || `${tData.name}_notes`}
                                                        id={tData.notesName || `${tData.name}_notes`}
                                                        value={props.formData[tData.notesName || `${tData.name}_notes`] || ''}
                                                        changeHandler={(value) => props.changeHandler(tData.notesName || `${tData.name}_notes`, value)}
                                                        readOnly={readOnly}
                                                        placeholder={`${tData.label} notes`}
                                                    />
                                                ) : null}
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
        </>
    )
}

YesOrNoFields.defaultProps = {
    appendClass: 'mt-3',
    failedValue: null,
    validation: {},
    showNotes: false
}
 
export default YesOrNoFields;